import { Observable, throwError as observableThrowError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';

import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ApiClient {
  API_URL = environment.api_url;

  constructor(
    private http: HttpClient,
    private route: Router,
    private authenticationService: AuthenticationService
  ) {}

  createAuthorizationHeader(headers: HttpHeaders) {
    return headers.append('Token', this.authenticationService.token);
  }

  processRequest(request: Observable<any>) {
    return request.pipe(
      catchError((error) => {
        if (error.status === 401) {
          this.authenticationService.notAuthenticated();
        }
        throw error;
      })
    );
  }

  get<T>(url, options = {}) {
    let headers = new HttpHeaders({ ...((options as any)?.headers ?? {}) });
    headers = this.createAuthorizationHeader(headers);
    let request = this.http.get<T>(this.API_URL + url, {
      ...options,
      headers: headers
    });

    request = this.processRequest(request);

    return request;
  }

  getBlob(url): Observable<Blob> {
    let headers = new HttpHeaders();
    headers = this.createAuthorizationHeader(headers);
    let request = this.http.get(this.API_URL + url, {
      headers: headers,
      responseType: 'blob'
    });

    this.processRequest(request);

    return request;
  }

  getResponse(url, customHeaders = {}) {
    const headers = this.createAuthorizationHeader(
      new HttpHeaders({ ...customHeaders })
    );
    let request = this.http.get(this.API_URL + url, {
      headers: headers,
      responseType: 'text'
    });

    this.processRequest(request);

    return request;
  }

  post<T>(url, data, options = {}) {
    const headers = new HttpHeaders(options['headers'] ?? {});
    options['headers'] = this.createAuthorizationHeader(headers);
    const request = this.http.post<T>(this.API_URL + url, data, options);
    this.processRequest(request);

    return request;
  }

  put<T>(url, data) {
    let headers = new HttpHeaders();
    headers = this.createAuthorizationHeader(headers);
    let request = this.http.put<T>(this.API_URL + url, data, {
      headers: headers
    });

    this.processRequest(request);

    return request;
  }

  delete<T>(url) {
    let headers = new HttpHeaders();
    headers = this.createAuthorizationHeader(headers);
    let request = this.http.delete<T>(this.API_URL + url, {
      headers: headers
    });

    this.processRequest(request);

    return request;
  }

  getWiths(include: string[]) {
    let qs = '';
    if (include.length) {
      qs = '?with[]=';
      include.forEach((inc, i) => {
        qs += inc;
        if (i !== include.length - 1) {
          qs += '&with[]=';
        }
      });
    }
    return qs;
  }

  urlSerializeArray(array: string[], key) {
    let qs = '';
    if (array.length) {
      qs = `${key}[]=`;
      array.forEach((inc, i) => {
        qs += encodeURIComponent(inc);
        if (i !== array.length - 1) {
          qs += `&${key}[]=`;
        }
      });
    }
    return qs;
  }
}
